import { render, staticRenderFns } from "./tp-verification.vue?vue&type=template&id=98425466&scoped=true"
import script from "./tp-verification.vue?vue&type=script&lang=js"
export * from "./tp-verification.vue?vue&type=script&lang=js"
import style0 from "./tp-verification.vue?vue&type=style&index=0&id=98425466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98425466",
  null
  
)

export default component.exports